import { Component, Inject, OnInit } from '@angular/core';
import { DialogResultConfirmComponent } from '../../../remote/game/dialog-result-confirm/dialog-result-confirm.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-dialog-game-result',
  templateUrl: './dialog-game-result.component.html',
  styleUrls: ['./dialog-game-result.component.scss']
})
export class DialogGameResultComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DialogResultConfirmComponent>,
              @Inject(MAT_DIALOG_DATA) public data: {}) {

    console.log(data)
  }

  ngOnInit() {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/digi/digi-game/dialog-game-result/dialog-game-result.component.ts